import { HTTP } from "@/shared/services/Http.service";

const http = HTTP();

/**
 * Valida si una matrícula de abogado existe en la base de datos
 * @param matricula Número de matrícula a validar
 * @returns Promise con el resultado de la validación
 */
export const ValidarMatriculaAbogado = (matricula: string): Promise<{ valido: boolean; mensaje?: string }> => {
  return http.Get(`/api/matriculas/validar/${matricula}`);
};